module.exports = __webpack_public_path__ + "static/media/YM19_2.cbe8c5c0.jpg";